import { render, staticRenderFns } from "./AttachmentViewer.vue?vue&type=template&id=cad80f86"
import script from "./AttachmentViewer.vue?vue&type=script&lang=js"
export * from "./AttachmentViewer.vue?vue&type=script&lang=js"
import style0 from "./AttachmentViewer.vue?vue&type=style&index=0&id=cad80f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports